import { render } from "./editMemo.vue?vue&type=template&id=490c8d56&scoped=true"
import script from "./editMemo.vue?vue&type=script&lang=js"
export * from "./editMemo.vue?vue&type=script&lang=js"

import "./editMemo.vue?vue&type=style&index=0&id=490c8d56&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490c8d56"]])

export default __exports__